var React = require('react');

function IconPlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32,0C14.33,0,0,14.33,0,32c0,17.67,14.33,32,32,32s32-14.33,32-32C64,14.33,49.67,0,32,0z\n\t M25.94,43.02V20.98L45.03,32L25.94,43.02z"}));
}

IconPlay.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 64 64","xmlSpace":"preserve"};

module.exports = IconPlay;

IconPlay.default = IconPlay;
